// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  
  
  
  class UpdateRental extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        file_formats:[],
        file : null,
        venue_list: [],    
        selected_venue:'',
      };
      this.handleSubmit = this.handleSubmit.bind(this);
      this.post_xls = this.post_xls.bind(this);
      this.fileHandler = this.fileHandler.bind(this);
      this.handleVenueChange = this.handleVenueChange.bind(this)
  
    }
  
  
    componentDidMount() {
        this.getVenues();
    }

    handleVenueChange(event) {
        this.setState({selected_venue:event.target.value})
      }
  
    
    
  
      post_xls(){
      const url = `${getLocationOrigin()}/lead/playo_xls_upload/`;
                  const options = {...defaultOptions};
                  var formData = new FormData();
                  formData.append('file', this.state.file);
                  formData.append('venue_id',this.state.selected_venue);
                  options['method'] = 'post';
  
                  options['body'] = formData;
                  console.log('Going to fetch');
      return fetch(url, options)
                  .then(checkStatus)
                  .then(parseJSON)
                  .then((response) => {
                      console.log(response)
                      alert(response.message)          
                  })
                  .catch(error => {
                      console.log(error);
                      alert(error.message);
                  });
    }
  
    fileHandler = (event) => {
      let fileObj = event.target.files[0];
      this.setState({file :fileObj});
      this.btn.removeAttribute("disabled");
    }


    getVenues(){
        const url = `${getLocationOrigin()}/get_venue_list/get_venues_for_buddy/`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
             this.setState({venue_list:data.result,selected_venue:data.result[0].id});
             // alert("fix");
         }).catch(error => error);
      }
  
  
    handleSubmit(event) {
      event.preventDefault();
        if(this.state.selected_venue){
        this.post_xls();   
        }
        else{
            alert("Please Select Venue")
        } 
    }

    render() {
      console.log(this.state)
  
      return(
        <div>
        <div style={{...styles.container}}>
          
              <div className="row col-md-8 table-bordered" style={styles.table}>
                <div style={styles.main_header} className="col-md-12">
                  <h3 style={{textAlign:'center'}}>Update Rental</h3>
                </div>
                <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
                    <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                            Venue
                        </div>
                        <select name="venue_id" className="col-md-6" style={styles.item_body} value={this.state.value}
                        onChange={this.handleVenueChange}>
                            {
                            this.state.venue_list.map((list,index)=>
                                <option key={list.id} value={list.id}>{list.name}</option>
                                )
                            }
                        </select>
                    </div>
                  <div style={styles.button_submit} className="col-md-12">
                    
                    <input type="file" className="col-md-6" onChange={this.fileHandler.bind(this)} style={{"padding":"10px"}} />
                    
                    <input className="btn btn-lg" ref={btn => { this.btn = btn; }}  onClick={this.handleSubmit} type="button" value="Upload " style={{
                        backgroundColor:'#302C35',
                        backgroundColor:'#009688',
                        color:'#ffffff'
                    }}/>
  
  
                  </div>
                </form>
              </div>
          
            
          
        </div>
      </div>
      );
    }
  }
  
  export default UpdateRental;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/updateRental/index.js